import React from "react";
import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { StratoButton } from "@/components/common/StratoButton";
import { Section } from "@/components/layout/Section";

export default function NotFound() {
  return (
    <SiteLayout>
      <PageHero
        testId="notfound-page"
        micro="ERRORE 404"
        title="Pagina non trovata."
        description="La pagina che cerchi non esiste o è stata spostata."
      />
      <Section id="notfound-body" tone="light">
        <div className="flex justify-center">
          <StratoButton as={Link} to="/" data-testid="notfound-home">
            Torna alla home
          </StratoButton>
        </div>
      </Section>
    </SiteLayout>
  );
}
